export default __webpack_public_path__ + "static/media/product_02.ba5bb0e0.png";